import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { Survey } from '@/types/survey';

/**
 * Retrieve a survey from the API.
 *
 * @param surveyId - The id of the survey to retrieve from the API.
 * @returns A Promise resolving to the Axios response containing the Survey.
 */
export async function surveyGetQuery(
  surveyId: string,
): Promise<AxiosResponse<Survey>> {
  const requestOptions = {
    method: 'GET',
    url: `/surveys/${surveyId}/`,
    params: {
      expand: "optionSets,steps"
    },
  };
  return api(requestOptions);
}

/**
 * Retrieve a personalized survey from the API.
 *
 * @param contentSelectionStrategy - The strategy for selecting a subset of content/items to administer.
  @param respondentId - The id of the respondent for whom to personalize the survey.
 * @param surveyId - The id of the survey to retrieve from the API.
 * @returns A Promise resolving to the Axios response containing the Survey.
 */
export async function personalizedSurveyGetQuery(
  contentSelectionStrategy: string,
  respondentId: string,
  surveyId: string,
): Promise<AxiosResponse<Survey>> {
  const requestOptions = {
    method: 'GET',
    url: `/surveys/${surveyId}/personalized/?respondent=${respondentId}&contentSelectionStrategy=${contentSelectionStrategy}`,
    params: {
      expand: "optionSets,steps"
    },
  };
  return api(requestOptions);
}